/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfReport } from '../models/data-page-of-report';
import { Report } from '../models/report';
import { ReportCategoryDto } from '../models/report-category-dto';
import { ReportDto } from '../models/report-dto';
import { ReportingSetting } from '../models/reporting-setting';
import { ReportParamDto } from '../models/report-param-dto';
import { reportsAddReport } from '../fn/reports/reports-add-report';
import { ReportsAddReport$Params } from '../fn/reports/reports-add-report';
import { reportsCreatePdf } from '../fn/reports/reports-create-pdf';
import { ReportsCreatePdf$Params } from '../fn/reports/reports-create-pdf';
import { reportsDelete } from '../fn/reports/reports-delete';
import { ReportsDelete$Params } from '../fn/reports/reports-delete';
import { reportsGet } from '../fn/reports/reports-get';
import { ReportsGet$Params } from '../fn/reports/reports-get';
import { reportsGetAllReportCategories } from '../fn/reports/reports-get-all-report-categories';
import { ReportsGetAllReportCategories$Params } from '../fn/reports/reports-get-all-report-categories';
import { reportsGetDsnList } from '../fn/reports/reports-get-dsn-list';
import { ReportsGetDsnList$Params } from '../fn/reports/reports-get-dsn-list';
import { reportsGetRecord } from '../fn/reports/reports-get-record';
import { ReportsGetRecord$Params } from '../fn/reports/reports-get-record';
import { reportsGetReportParams } from '../fn/reports/reports-get-report-params';
import { ReportsGetReportParams$Params } from '../fn/reports/reports-get-report-params';
import { reportsGetReports } from '../fn/reports/reports-get-reports';
import { ReportsGetReports$Params } from '../fn/reports/reports-get-reports';
import { reportsGetReportType } from '../fn/reports/reports-get-report-type';
import { ReportsGetReportType$Params } from '../fn/reports/reports-get-report-type';
import { reportsGetReportTypeList } from '../fn/reports/reports-get-report-type-list';
import { ReportsGetReportTypeList$Params } from '../fn/reports/reports-get-report-type-list';
import { reportsPut } from '../fn/reports/reports-put';
import { ReportsPut$Params } from '../fn/reports/reports-put';

@Injectable({ providedIn: 'root' })
export class ReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportsGetAllReportCategories()` */
  static readonly ReportsGetAllReportCategoriesPath = '/reports/getallcategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetAllReportCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetAllReportCategories$Response(params?: ReportsGetAllReportCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportCategoryDto>>> {
    return reportsGetAllReportCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetAllReportCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetAllReportCategories(params?: ReportsGetAllReportCategories$Params, context?: HttpContext): Observable<Array<ReportCategoryDto>> {
    return this.reportsGetAllReportCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportCategoryDto>>): Array<ReportCategoryDto> => r.body)
    );
  }

  /** Path part for operation `reportsGetDsnList()` */
  static readonly ReportsGetDsnListPath = '/reports/getDsnList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetDsnList()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetDsnList$Response(params?: ReportsGetDsnList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportingSetting>>> {
    return reportsGetDsnList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetDsnList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetDsnList(params?: ReportsGetDsnList$Params, context?: HttpContext): Observable<Array<ReportingSetting>> {
    return this.reportsGetDsnList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportingSetting>>): Array<ReportingSetting> => r.body)
    );
  }

  /** Path part for operation `reportsGetReportType()` */
  static readonly ReportsGetReportTypePath = '/api/Reports/report/reportType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetReportType()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportType$Response(params?: ReportsGetReportType$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReport>> {
    return reportsGetReportType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetReportType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportType(params?: ReportsGetReportType$Params, context?: HttpContext): Observable<DataPageOfReport> {
    return this.reportsGetReportType$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfReport>): DataPageOfReport => r.body)
    );
  }

  /** Path part for operation `reportsGetReportTypeList()` */
  static readonly ReportsGetReportTypeListPath = '/api/Reports/report/reportTypeList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetReportTypeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportTypeList$Response(params?: ReportsGetReportTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Report>>> {
    return reportsGetReportTypeList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetReportTypeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportTypeList(params?: ReportsGetReportTypeList$Params, context?: HttpContext): Observable<Array<Report>> {
    return this.reportsGetReportTypeList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Report>>): Array<Report> => r.body)
    );
  }

  /** Path part for operation `reportsGet()` */
  static readonly ReportsGetPath = '/api/Reports/report/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGet$Response(params?: ReportsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReport>> {
    return reportsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGet(params?: ReportsGet$Params, context?: HttpContext): Observable<DataPageOfReport> {
    return this.reportsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfReport>): DataPageOfReport => r.body)
    );
  }

  /** Path part for operation `reportsGetRecord()` */
  static readonly ReportsGetRecordPath = '/api/Reports/report/singlerecord';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetRecord()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetRecord$Response(params?: ReportsGetRecord$Params, context?: HttpContext): Observable<StrictHttpResponse<Report>> {
    return reportsGetRecord(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetRecord$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetRecord(params?: ReportsGetRecord$Params, context?: HttpContext): Observable<Report> {
    return this.reportsGetRecord$Response(params, context).pipe(
      map((r: StrictHttpResponse<Report>): Report => r.body)
    );
  }

  /** Path part for operation `reportsGetReportParams()` */
  static readonly ReportsGetReportParamsPath = '/api/Reports/report/getReportParams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetReportParams()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportParams$Response(params?: ReportsGetReportParams$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParamDto>> {
    return reportsGetReportParams(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetReportParams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReportParams(params?: ReportsGetReportParams$Params, context?: HttpContext): Observable<ReportParamDto> {
    return this.reportsGetReportParams$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportParamDto>): ReportParamDto => r.body)
    );
  }

  /** Path part for operation `reportsCreatePdf()` */
  static readonly ReportsCreatePdfPath = '/report/createPDF';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsCreatePdf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsCreatePdf$Response(params: ReportsCreatePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    return reportsCreatePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsCreatePdf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsCreatePdf(params: ReportsCreatePdf$Params, context?: HttpContext): Observable<ReportDto> {
    return this.reportsCreatePdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportsGetReports()` */
  static readonly ReportsGetReportsPath = '/report/getReports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsGetReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReports$Response(params?: ReportsGetReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportsGetReports(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsGetReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsGetReports(params?: ReportsGetReports$Params, context?: HttpContext): Observable<Blob> {
    return this.reportsGetReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportsAddReport()` */
  static readonly ReportsAddReportPath = '/api/Reports/report/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAddReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsAddReport$Response(params: ReportsAddReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportsAddReport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAddReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsAddReport(params: ReportsAddReport$Params, context?: HttpContext): Observable<Blob> {
    return this.reportsAddReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportsPut()` */
  static readonly ReportsPutPath = '/api/Reports/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsPut$Response(params: ReportsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Report>> {
    return reportsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsPut(params: ReportsPut$Params, context?: HttpContext): Observable<Report> {
    return this.reportsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Report>): Report => r.body)
    );
  }

  /** Path part for operation `reportsDelete()` */
  static readonly ReportsDeletePath = '/api/Reports/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDelete$Response(params: ReportsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDelete(params: ReportsDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.reportsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
